import React from 'react';

const TamkeenLogo = ({ className = "w-12 h-12" }) => (
  <svg 
    className={className} 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      {/* التدرج اللوني الذي يتوافق مع هوية المنصة (أزرق إلى أخضر) */}
      <linearGradient id="tamkeen-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3b82f6" /> {/* blue-500 */}
        <stop offset="100%" stopColor="#10b981" /> {/* emerald-500 */}
      </linearGradient>
    </defs>
    
    {/* القوس السفلي التجريدي (قاعدة حرف التاء / رمز الاحتضان) */}
    <path 
      d="M 20 60 C 20 85, 80 85, 80 60" 
      stroke="url(#tamkeen-grad)" 
      strokeWidth="12" 
      strokeLinecap="round" 
      style={{ transition: 'all 0.3s ease' }}
    />
    
    {/* النقطة اليمنى (خضراء) */}
    <circle cx="65" cy="30" r="10" fill="#10b981" />
    
    {/* النقطة اليسرى (زرقاء) */}
    <circle cx="35" cy="30" r="10" fill="#3b82f6" />
  </svg>
);

export default TamkeenLogo;